<table mat-table [dataSource]="netzverknuepfungenList()" data-qa="netzverknuepfungen-table">
    <ng-container matColumnDef="stadtwerkName">
        <th mat-header-cell *matHeaderCellDef>Betroffene Stadtwerke (Top 10)</th>
        <td mat-cell *matCellDef="let element"> {{element.stadtwerkName}} </td>
    </ng-container>

    <ng-container matColumnDef="stadtwerkId">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let element"> {{element.stadtwerkId}} </td>
    </ng-container>

    <ng-container matColumnDef="countUngueltigeAnlagen">
        <th mat-header-cell *matHeaderCellDef>Ungültige Anlagen</th>
        <td mat-cell *matCellDef="let element">{{element.countUngueltigeAnlagen}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
